import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class TrackingAndSeoService {
  private windowRef = window as any;
  private scriptSrc;

  constructor(private pageTitle: Title, private meta: Meta) {}

  /**
   *
   * @param title New page title
   */
  updatePageTitle(title: string) {
    this.pageTitle.setTitle(title);
  }

  /**
   *
   * @param content New content for description META tag.
   */
  updateDescription(metaContent: string) {
    this.meta.updateTag({ name: 'description', content: metaContent });
  }

  /**
   * Script URL is specific to ENVIRONMENT. (QA / PROD)
   * @example
   * pre-prod : //tags.tiqcdn.com/utag/theaa/insurance/qa/utag.js
   *     prod : //tags.tiqcdn.com/utag/theaa/insurance/prod/utag.js
   */
  setAnalyticsConfig(scriptUrl) {
    // Disable first page automatic view event for Single Page Apps (SPAs)
    this.windowRef.utag_cfg_ovrd = { noview: true };
    this.windowRef.utag_data = {};

    this.scriptSrc = scriptUrl;
  }

  /**
   * Used for tracking page views
   * @param data
   */
  view(data?: any) {
    this.track('view', data);
  }

  /**
   * Used for tracking custom events
   * @param data
   */
  link(data?: any) {
    this.track('link', data);
  }

  private track(eventType: 'view' | 'link', data?: any) {
    if (!this.scriptSrc) {
      console.warn('Tealium utag script src is not set. Call setAnalyticsConfig method with script src url.');
      return;
    }

    if (this.windowRef.utag) {
      this.windowRef.utag.track(eventType, data);
    } else {
      // Lazy load the tracking functionality on demand
      this.getScript(this.scriptSrc, () => {
        this.windowRef.utag.track(eventType, data);
      });
    }
  }

  private getScript(src: string, callback) {
    if (!this.windowRef.document.addEventListener) {
      console.warn('AnalyticsAndSEOService - Un-supported browser');
      return;
    }

    const firstScriptEl = this.windowRef.document.getElementsByTagName('script')[0];
    const scriptEl = this.windowRef.document.createElement('script');
    scriptEl.language = 'javascript';
    scriptEl.type = 'text/javascript';
    scriptEl.async = 1;
    scriptEl.charset = 'utf-8';
    scriptEl.src = src;

    scriptEl.addEventListener('load', callback, false);

    firstScriptEl.parentNode.insertBefore(scriptEl, firstScriptEl);
  }
}
